/**
 * @function loadScript
 * @param {string} source
 * @param {Function} callback
 *
 * Injects and loads a specific script.
 * 1. Creates the script tag.
 * 2. Injects the script tag.
 */
export const loadScript = (source, callback = () => {}) => {
    /* [1] */
    const script = document.createElement('script');
    script.src = source;
    script.addEventListener('load', callback);

    /* [2] */
    document.body.appendChild(script);
};
